import { motion } from "framer-motion";
import { useLightbox } from "@/components/Lightbox";
import { useSlowFactor } from "@/hooks/useSlowFactor";
import { useLanguage } from "@/i18n/LanguageContext";

const PROCESS_IMG = "/flow-bench.png";

export const Process = () => {
  const { open } = useLightbox();
  const slow = useSlowFactor();
  const { t } = useLanguage();
  const steps = t.process.steps.map((s, i) => ({ ...s, n: String(i + 1).padStart(2, "0") }));
  return (
    <section id="process" data-testid="process-section" className="py-16 sm:py-24 lg:py-32 carbon border-y border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative group overflow-hidden photo-frame">
            <img
              src={PROCESS_IMG}
              alt="G3 min-Flow bench"
              onClick={() => open(PROCESS_IMG, "G3 min-Flow bench")}
              className="w-full h-[300px] sm:h-[480px] object-cover brightness-110 cursor-pointer transition-transform duration-[600ms] ease-out group-hover:scale-105"
            />
            <div className="absolute bottom-3 left-3 block bg-red-600 text-white px-3 py-2 max-w-[180px] shadow-[0_0_30px_rgba(239,68,68,0.5)]">
              <p className="font-display font-bold text-lg sm:text-xl leading-none tracking-tight">{t.process.benchTitle}</p>
              <p className="text-[11px] text-red-100 mt-1 leading-tight">{t.process.benchDesc}</p>
            </div>
          </div>

          <div>
            <p className="text-sm font-bold uppercase tracking-[0.25em] text-red-500 mb-4">{t.process.eyebrow}</p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight leading-tight text-white mb-10">
              {t.process.heading}
            </h2>

            <div className="space-y-8">
              {steps.map((s, i) => (
                <motion.div
                  key={s.n}
                  data-testid={`process-step-${i}`}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.58 * slow, delay: i * 0.14 * slow }}
                  className="flex gap-6 border-b border-zinc-800 pb-8 last:border-0"
                >
                  <span className="font-display font-bold text-3xl text-red-500 shrink-0 w-14">{s.n}</span>
                  <div>
                    <h3 className="font-display font-bold text-xl uppercase tracking-tight text-white mb-2">
                      {s.title}
                    </h3>
                    <p className="text-zinc-300 leading-relaxed">{s.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
